<template>
  <div
    v-tooltip="{
      content: text,
      placement: 'top',
      html,
    }"
    class="tip tooltip-target b3"
  >
    <svg-icon :width="'10'" :height="'10'" icon="app-icons/help" />
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    text: {
      type: String,
      default: null,
    },
    html: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      closeTimer: 0,
    };
  },

  computed: {},

  methods: {},
};
</script>

<style scoped lang="scss">
.tip {
  background: #252929;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #db841e;
  width: 22px;
  height: 22px;
  cursor: help;
  margin: 0 0 0 10px;
  &:hover {
    background: #0d0e0e;
  }
}
</style>
